var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerTeeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-srv-c320": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 220.619 192.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-srv-c320": "",
    id: "lower_arch",
    "data-name": "lower arch",
    transform: "translate(1.001 1.002)",
    className: "tooth"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 32,
    "data-name": "Path 415",
    d: "M441.788,959.245c-2.112.934-3.245,7.074-2.763,11.293a80.724,80.724,0,0,0,1.313,8.314c.4,1.811,1.9,4.224,3.942,3.8a39.112,39.112,0,0,0,6.825-2.425,39.671,39.671,0,0,0,6.385-3.432c1.688-1.224.9-3.953-.175-5.469a80.672,80.672,0,0,0-5.286-6.548c-2.809-3.186-8.121-6.469-10.241-5.529",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL2"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 33,
    "data-name": "Path 416",
    d: "M456.107,948.081c2.2-1.747,6.594-.626,9.765.393s9.7,5.295,11.171,6.83c.4.412,2.078,2.621,1.5,4.322-1.342,3.9-4.253,10.132-4.879,10.631s-7.361,1.9-11.47,2.309c-1.787.174-3.548-1.965-3.853-2.454-1.165-1.775-3.826-9.11-4.091-12.439s-.5-7.733,1.855-9.592",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL3"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 34,
    "data-name": "Path 417",
    d: "M469.376,934.951c-2.387,3.91-2.236,8.408-.84,10.543,1.21,1.874,10.6,9.368,12.912,9.452,2.642.1,7.24-2.692,9.77-6.831s2.892-9.487,1.583-11.765c-1.138-2-12.169-6.809-14.4-7.016-2.552-.237-6.636,1.712-9.021,5.617",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL4"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 35,
    "data-name": "Path 418",
    d: "M477.949,914.9c-1.692,4.769-.5,9.6,1.5,11.6,1.738,1.749,13.61,7.711,16.123,7.269,2.88-.5,7.218-4.558,9.006-9.615s.964-10.922-.969-13.085c-1.688-1.9-14.716-4.587-17.183-4.3-2.812.333-6.786,3.365-8.473,8.135",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL5"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 31,
    "data-name": "Path 419",
    d: "M428.456,960.537c-4.041.4-6.427,16.714-6.664,20.163-.139,2.061.532,5.155,2.461,5.452a30.285,30.285,0,0,0,6.735-.037,31.3,31.3,0,0,0,6.6-1.275c1.839-.671,1.894-3.841,1.351-5.837-.9-3.343-6.44-18.867-10.487-18.466",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL1"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 36,
    "data-name": "Path 420",
    d: "M482.2,884.141c-2.093,2.5-4.6,9.044-1.833,13.3,4.044,6.245,9.7,7.428,14.208,8.947s12.426,2.76,16.194.062c4.322-3.1,5.276-8.77,3.855-13.519,3.623-3.382,5.67-8.758,3.5-13.613-1.887-4.239-9.352-7.166-14.006-8.135s-10.133-2.8-16.779.545c-4.538,2.28-5.681,9.192-5.142,12.409",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL6"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 37,
    "data-name": "Path 421",
    d: "M490.887,848.245c-1.875,2.673-3.817,9.4-.7,13.414,4.558,5.878,10.3,6.582,14.913,7.711s12.616,1.7,16.145-1.31c4.042-3.451,4.513-9.184,2.7-13.8,3.325-3.679,4.905-9.206,2.341-13.861-2.241-4.061-9.928-6.35-14.646-6.919s-10.334-1.933-16.676,1.961c-4.325,2.659-4.882,9.642-4.07,12.8",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL7"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 38,
    "data-name": "Path 422",
    d: "M494.015,813.349c-1.477,2.909-2.455,9.844,1.193,13.379,5.343,5.174,11.124,5.064,15.853,5.535s12.728-.095,15.8-3.574c3.516-3.985,3.173-9.725.726-14.037,2.775-4.109,3.56-9.8.365-14.049-2.792-3.708-10.722-4.891-15.473-4.789s-10.507-.46-16.232,4.286c-3.912,3.242-3.481,10.234-2.23,13.249",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LL8"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 42,
    "data-name": "Path 423",
    d: "M399.649,959.245c2.113.934,3.246,7.074,2.763,11.293a80.431,80.431,0,0,1-1.312,8.314c-.4,1.811-1.9,4.224-3.943,3.8a39.1,39.1,0,0,1-6.824-2.425,39.67,39.67,0,0,1-6.385-3.432c-1.688-1.224-.9-3.953.174-5.469a81.1,81.1,0,0,1,5.286-6.548c2.81-3.186,8.122-6.469,10.241-5.529",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR2"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 43,
    "data-name": "Path 424",
    d: "M385.33,948.081c-2.2-1.747-6.593-.626-9.765.393s-9.7,5.295-11.17,6.83c-.4.412-2.078,2.621-1.5,4.322,1.341,3.9,4.253,10.132,4.879,10.631s7.36,1.9,11.47,2.309c1.787.174,3.548-1.965,3.853-2.454,1.164-1.775,3.825-9.11,4.091-12.439s.5-7.733-1.856-9.592",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR3"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 44,
    "data-name": "Path 425",
    d: "M372.062,934.951c2.387,3.91,2.235,8.408.84,10.543-1.211,1.874-10.6,9.368-12.912,9.452-2.642.1-7.24-2.692-9.77-6.831s-2.893-9.487-1.584-11.765c1.139-2,12.169-6.809,14.4-7.016,2.552-.237,6.636,1.712,9.021,5.617",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR4"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 45,
    "data-name": "Path 426",
    d: "M363.489,914.9c1.691,4.769.5,9.6-1.5,11.6-1.738,1.749-13.611,7.711-16.123,7.269-2.881-.5-7.218-4.558-9.007-9.615s-.964-10.922.97-13.085c1.688-1.9,14.716-4.587,17.182-4.3,2.813.333,6.787,3.365,8.474,8.135",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR5"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 41,
    "data-name": "Path 427",
    d: "M412.981,960.537c4.042.4,6.428,16.714,6.665,20.163.139,2.061-.532,5.155-2.461,5.452a30.285,30.285,0,0,1-6.735-.037,31.29,31.29,0,0,1-6.6-1.275c-1.839-.671-1.894-3.841-1.351-5.837.9-3.343,6.44-18.867,10.486-18.466",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR1"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 46,
    "data-name": "Path 428",
    d: "M359.24,884.141c2.094,2.5,4.6,9.044,1.834,13.3-4.045,6.245-9.7,7.428-14.208,8.947s-12.426,2.76-16.194.062c-4.322-3.1-5.276-8.77-3.855-13.519-3.623-3.382-5.671-8.758-3.5-13.613,1.887-4.239,9.351-7.166,14.006-8.135s10.132-2.8,16.779.545c4.538,2.28,5.681,9.192,5.141,12.409",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR6"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 47,
    "data-name": "Path 429",
    d: "M350.551,848.245c1.874,2.673,3.816,9.4.7,13.414-4.559,5.878-10.3,6.582-14.913,7.711s-12.616,1.7-16.145-1.31c-4.042-3.451-4.513-9.184-2.7-13.8-3.326-3.679-4.9-9.206-2.341-13.861,2.241-4.061,9.927-6.35,14.646-6.919s10.334-1.933,16.676,1.961c4.325,2.659,4.882,9.642,4.07,12.8",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR7"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-srv-c320": "",
    id: 48,
    "data-name": "Path 430",
    d: "M347.423,813.349c1.477,2.909,2.454,9.844-1.193,13.379-5.343,5.174-11.124,5.064-15.853,5.535s-12.728-.095-15.8-3.574c-3.517-3.985-3.173-9.725-.726-14.037-2.775-4.109-3.56-9.8-.366-14.049,2.793-3.708,10.722-4.891,15.474-4.789s10.506-.46,16.232,4.286c3.912,3.242,3.481,10.234,2.23,13.249",
    transform: "translate(-311.411 -795.808)",
    fill: "white",
    stroke: "#FA2C46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-title": "LR8",
    className: "dp-selected"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerTeeth);
export default __webpack_public_path__ + "static/media/lower-teeth.5f218197c205877f96d54a8ccf82b09c.svg";
export { ForwardRef as ReactComponent };